'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.provider("initialisationService", function () {
  var rootScopeInitializedProp = "appInitialized";
  var handlers = [];
  return {
    addInitialisationHandler: function addInitialisationHandler(handler) {
      handlers.push(handler);
    },
    $get: function $get($q, $rootScope, $injector) {
      return {
        executeHandlers: function executeHandlers() {
          var invokedHandlers = _.map(handlers, function (handler) {
            return $injector.invoke(handler);
          });
          return $q.all(invokedHandlers).then(function () {
            $rootScope[rootScopeInitializedProp] = true;
          });
        }
      };
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/services/initialisationService.js
// module id = 2876
// module chunks = 13